import { render, staticRenderFns } from "./LiabilityType.vue?vue&type=template&id=6773b82a"
import script from "./LiabilityType.vue?vue&type=script&lang=js"
export * from "./LiabilityType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports